export default __webpack_public_path__ + "static/media/token_wsOHM.12b09bc9.svg";